import type { FC } from 'react';

import type { MetricAccent } from '@/common-components/MetricCard';
import ProgressBarRow from '@/common-components/charts/ProgressBarRow';
import type { CampusActivityItem } from '@/types/stats.types';

interface CampusActivityCardProps {
  items: CampusActivityItem[];
}

// The prototype cycles a different colour per campus row; these are the @theme equivalents.
const ACCENTS: MetricAccent[] = ['brand', 'info', 'success', 'pink', 'warn'];

const CampusActivityCard: FC<CampusActivityCardProps> = ({ items }) => (
  <section className="rounded-2xl border border-[var(--color-divider)] bg-white p-6 shadow-[var(--shadow-card)]">
    <header className="mb-4">
      <h2 className="text-[15px] font-extrabold text-[var(--color-ink)]">Campus Activity</h2>
      <p className="text-[12px] text-[var(--color-ink-muted)]">Top campuses this week</p>
    </header>

    {items.length === 0 ? (
      <p className="py-8 text-center text-[13px] text-[var(--color-ink-muted)]">
        No bookings on any campus this week.
      </p>
    ) : (
      <div className="flex flex-col gap-3.5">
        {items.map((item, index) => (
          <ProgressBarRow
            key={item.campusId}
            label={item.name}
            value={`${item.bookings}`}
            percent={item.percent}
            accent={ACCENTS[index % ACCENTS.length] ?? 'brand'}
          />
        ))}
      </div>
    )}
  </section>
);

export default CampusActivityCard;
